export const userKeys = {
  user: ['user'] as const,
  login: () => [...userKeys.user, 'login'] as const,
  logout: () => [...userKeys.user, 'logout'] as const,
  refresh: () => [...userKeys.user, 'refresh-token'] as const,
}
